import React, { useEffect, useState, useContext } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Grid, Button, Typography, TextField, Box, FormHelperText } from '@mui/material';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Input, Label, FormFeedback } from 'reactstrap';
import PaymentState from 'Hooks/Payment.state';
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { AccountValidation } from 'Utils/Validations';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import FileValidations from '../FileValidation/FileValidations';
import PhoneInput from 'react-phone-input-2'
import { UserContext } from 'Hooks/UserContext';
import utc from 'dayjs/plugin/utc';
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us";

dayjs.extend(utc);
const elementStyle = {
    style: {
        base: {
            fontSize: '16px',
            color: '#424770',
            '::placeholder': {
                color: '#aab7c4',
            },
            border: '1px solid #ced4da', // Border style
            padding: '10px',
            borderRadius: '4px',
        },
        invalid: {
            color: '#fa755a',
        },
    },
};
const PaymentComponent = ({ isMobile, driveWithUsData = [] }) => {
    const [selectedDate, setSelectedDate] = useState(null)
    const { CheckFile, fileError } = FileValidations()
    const [idCard, setIdCard] = useState(null)
    const { saveAccountInfo, formBusy, accountResult, getAccountInfo, account, updateAccountInfo } = PaymentState()
    const { control, handleSubmit, formState: { errors }, setValue } = useForm({

        resolver: yupResolver(AccountValidation)
    })
    const { user } = useContext(UserContext)
    const onSubmit = (d) => {
        const data = {
            ...d,
            dob: selectedDate
        }
        const formData = new FormData()
        formData.append("first_name", d.first_name)
        formData.append("last_name", d.last_name)
        formData.append("email", d.email)
        formData.append("phone", d.phone)
        formData.append("bank_name", d.bank_name)
        formData.append("account_number", d.account_number)
        formData.append("routing_number", d.routing_number)
        formData.append("dob", d.dob)
        formData.append("business_profile_mcc", 4121)
        formData.append("ssn_number", d.ssn_number)
        formData.append("address_line1", d.address_line1)
        formData.append("address_line2", d.address_line2)
        formData.append("city", d.city)
        formData.append("state", d.state)
        formData.append("postal_code", d.postal_code)
        formData.append("identity", idCard)
        saveAccountInfo(formData)
    }

    useEffect(() => {
        getAccountInfo()
    }, [accountResult])

    useEffect(() => {
        if (account !== null) {
            setValue("first_name", account.first_name || "")
            setValue("last_name", account.last_name || "")
            setValue("email", user?.email || "")
            setValue("phone", user?.phone || "")
            setValue("bank_name", account.bank_name || "")
            setValue("account_number", account.account_number || "")
            setValue("confirm_account_number", account.account_number || "")
            setValue("routing_number", account.routing_number || "")
            setValue("dob", dayjs(account.dob) || "")
            setSelectedDate(account.dob)
            // setValue("business_profile_mcc", 4121 || "")
            if (user?.form_name === "drive_with_us") {
                const ssn = driveWithUsData.find((i) => i.field_name === "social_security")
                if (ssn || ssn !== undefined) {

                    setValue("ssn_number", ssn || "")
                }
            } else {
                setValue("ssn_number", account.ssn_number || "")
            }

            if (user?.form_name === "free_ride") {
                setValue("address_line1", account.address_line1 || "")
                setValue("city", account.city || "")
                setValue("state", account.state || "")
                setValue("postal_code", account.postal_code || "")
            } else {
                setValue("address_line1", user?.address || "")
                setValue("city", user?.city || "")
                setValue("state", user?.state || "")
                setValue("postal_code", user?.postal_code || "")
            }

            setValue("address_line2", account.address_line2 || "")


            // setValue("identity", account.identity || "")
        } else {

            setValue("first_name", user?.first_name || "")
            setValue("last_name", user?.last_name || "")
            setValue("email", user?.email || "")
            setValue("phone", user?.phone || "")
            setValue("dob", user?.dob || "")
            setSelectedDate(user?.dob)
            setValue("address_line1", user?.address || "")
            setValue("city", user?.city || "")
            setValue("state", user?.state || "")
            setValue("postal_code", user?.zip_code || "")
            const ssn = driveWithUsData.find((i) => i.field_name === "social_security")
            if (ssn || ssn !== undefined) {

                setValue("ssn_number", ssn.file_number || "")
            }

        }
    }, [account, user, driveWithUsData])

    const updateAccount = (d) => {
        const data = {
            ...d,
            dob: selectedDate,
            id: account._id
        }
        const formData = new FormData()
        formData.append("id", account._id)
        formData.append("first_name", d.first_name)
        formData.append("last_name", d.last_name)
        formData.append("email", d.email)
        formData.append("phone", d.phone)
        formData.append("bank_name", d.bank_name)
        formData.append("account_number", d.account_number)
        formData.append("routing_number", d.routing_number)
        formData.append("dob", selectedDate)
        formData.append("business_profile_mcc", 4121)
        formData.append("ssn_number", d.ssn_number)
        formData.append("address_line1", d.address_line1)
        formData.append("address_line2", d.address_line2)
        formData.append("city", d.city)
        formData.append("state", d.state)
        formData.append("postal_code", d.postal_code)
        formData.append("identity", idCard)
        updateAccountInfo(formData)
    }

    const onChangeFiles = async (file, name) => {
        if (!file) {
            console.warn('No file selected');
            return;
        }

        try {
            // Add a small delay for mobile devices to ensure proper file handling
            await new Promise(resolve => setTimeout(resolve, 100));
            
            CheckFile(file, name);

            if (name === "identity") {
                setIdCard(file)
            }
        } catch (error) {
            console.error('Error handling file selection:', error);
        }
    }


    return (
        <div className='payment-section' >
            <ToastContainer />
            <>
                {/* <Typography mb={2} mt={2} variant="h5" px={3} >Account Information</Typography> */}
                <Grid container  >
                    <Grid xs={12} md={6} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="first_name"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>
                                    <label style={{ color: "#000" }} >First Name</label>
                                    <Input className='form-control p-2' fullWidth placeholder="First name" {...field} invalid={errors.first_name} />
                                    <FormFeedback invalid={errors.first_name} >{errors?.first_name?.message}</FormFeedback>
                                </>
                            )}
                        />

                    </Grid>
                    <Grid xs={12} md={6} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="last_name"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>
                                    <label style={{ color: "#000" }} >Last Name</label>
                                    <Input className='form-control p-2' fullWidth placeholder="Last name" {...field} invalid={errors.last_name} />
                                    <FormFeedback invalid={errors.last_name} >{errors?.last_name?.message}</FormFeedback>

                                </>
                            )}
                        />

                    </Grid>
                    {/* <Grid xs={12} md={6} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="email"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>
                                    <label style={{ color: "#000" }} >Email</label>
                                    <TextField fullWidth placeholder="Email" {...field} error={errors.email} helperText={errors?.email?.message} />

                                </>
                            )}
                        />

                    </Grid> */}
                    {/* <Grid sm={6} xs={12} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="phone"
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                                <>
                                    <label style={{ color: "#000" }}>Phone Number</label>
                                    <PhoneInput country={"us"} placeholder='Phone Number' value={value} onChange={(p) => onChange(p)} />
                                    {errors.phone ? <p className='error-message' > {errors?.phone?.message}</p> : null}
                                </>
                            )}
                        />



                    </Grid> */}
                    <Grid xs={12} md={6} mt={2} px={1} >

                        <Controller
                            control={control}
                            name="bank_name"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>
                                    <label style={{ color: "#000" }} >Bank Name</label>
                                    <Input className='form-control p-2' fullWidth placeholder="Bank name" {...field} invalid={errors.bank_name} />
                                    <FormFeedback invalid={errors.bank_name} >{errors?.bank_name?.message}</FormFeedback>

                                </>
                            )}
                        />


                    </Grid>
                    <Grid xs={12} md={6} mt={2} px={1} >
                        <Controller
                            control={control}
                            name="account_number"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>

                                    <label style={{ color: "#000" }} >Account Number</label>
                                    <Input className='form-control p-2' fullWidth placeholder="Account number" {...field} invalid={errors.account_number} />
                                    <FormFeedback invalid={errors.account_number} >{errors?.account_number?.message}</FormFeedback>

                                </>
                            )}
                        />

                    </Grid>
                    <Grid xs={12} md={6} mt={2} px={1} >
                        <Controller
                            control={control}
                            name="confirm_account_number"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>

                                    <label style={{ color: "#000" }} >Confirm Account Number</label>
                                    <Input className='form-control p-2' fullWidth placeholder="Confirm account number" {...field} invalid={errors.confirm_account_number} />
                                    <FormFeedback invalid={errors.confirm_account_number} >{errors?.confirm_account_number?.message}</FormFeedback>

                                </>
                            )}
                        />

                    </Grid>
                    <Grid xs={12} md={6} mt={2} px={1} >
                        <Controller
                            control={control}
                            name="routing_number"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>

                                    <label style={{ color: "#000" }} >Routing Number</label>
                                    <Input className='form-control p-2' fullWidth placeholder="Routing number" {...field} invalid={errors.routing_number} />
                                    <FormFeedback invalid={errors.routing_number} >{errors?.routing_number?.message}</FormFeedback>

                                </>
                            )}
                        />

                    </Grid>

                    <Grid xs={12} md={6} mt={2} px={1} >
                        <Controller
                            control={control}
                            name="dob"
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => {
                                return (
                                    <>
                                        <label style={{ color: "#000" }}>Date of Birth</label>
                                        <Input
                                            type='date'
                                            className='form-control p-2'
                                            value={value}
                                            onChange={onChange}

                                        />
                                        <FormFeedback invalid={errors.dob} >{errors?.dob?.message}</FormFeedback>
                                    </>
                                );
                            }}
                        />



                    </Grid>

                    {/* <Grid xs={12} md={6} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="business_profile_mcc"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>

                                    <label style={{ color: "#000" }} >Business Profile MCC</label>
                                    <TextField fullWidth placeholder="Business profile MCC" {...field} error={errors.business_profile_mcc} helperText={errors?.business_profile_mcc?.message} />

                                </>
                            )}
                        />

                    </Grid> */}
                    {(user?.form_name === "partner_with_us" || user?.form_name === "free_ride") && (
                        <Grid xs={12} md={6} mt={2} px={1} >
                            <Controller
                                control={control}
                                name="ssn_number"
                                rules={{ required: true }}
                                render={({ field: { onBlur, onChange, value } }) => (
                                    <>

                                        <label style={{ color: "#000" }} >Social Security Number </label>
                                        <Cleave
                                            placeholder="xxx-xx-xxxx"
                                            options={{
                                                delimiters: ['-', '-'],
                                                blocks: [3, 2, 4],
                                                uppercase: true
                                            }}
                                            value={value}
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            className={`form-control ${errors.ssn_number ? "is-invalid" : ""} p-2`}
                                            name="social_security_number"
                                            type="text"
                                            inputMode="text"
                                        />
                                        <FormFeedback invalid={errors.ssn_number} >{errors?.ssn_number?.message}</FormFeedback>
                                    </>
                                )}
                            />

                        </Grid>
                    )}
                    {user?.form_name === "free_ride" && (
                        <Grid xs={12} md={6} mt={2} px={1} >
                            <Controller
                                control={control}
                                name="address_line1"
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <>

                                        <label style={{ color: "#000" }} >Address Line 1</label>
                                        <Input  className='form-control p-2' fullWidth placeholder="Address line 1" {...field} invalid={errors.address_line1}  />
                                        <FormFeedback invalid={errors.address_line1} >{errors?.address_line1?.message}</FormFeedback>
                                    </>
                                )}
                            />

                        </Grid>
                    )}
                    {/* <Grid xs={12} md={6} mt={1} px={1} >
                        <Controller
                            control={control}
                            name="address_line2"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <>

                                    <label style={{ color: "#000" }} >Address Line 2</label>
                                    <TextField fullWidth placeholder="Address line 2" {...field} />

                                </>
                            )}
                        />

                    </Grid> */}
                    {user?.form_name === "free_ride" && (
                        <Grid xs={12} md={6} mt={2} px={1} >
                            <Controller
                                control={control}
                                name="city"
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <>

                                        <label style={{ color: "#000" }} >City</label>
                                        <Input  className='form-control p-2' fullWidth placeholder="City" {...field} invalid={errors.city}  />
                                        <FormFeedback invalid={errors.city} >{errors?.city?.message}</FormFeedback>

                                    </>
                                )}
                            />

                        </Grid>
                    )}
                    {user?.form_name === "free_ride" && (
                        <Grid xs={12} md={6} mt={2} px={1} >
                            <Controller
                                control={control}
                                name="state"
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <>

                                        <label style={{ color: "#000" }} >State</label>
                                        <Input  className='form-control p-2' fullWidth placeholder="State" {...field} invalid={errors.state} />
                                        <FormFeedback invalid={errors.state} >{errors?.state?.message}</FormFeedback>

                                    </>
                                )}
                            />

                        </Grid>
                    )}
                    {user?.form_name === "free_ride" && (
                        <Grid xs={12} md={6} mt={2} px={1} >
                            <Controller
                                control={control}
                                name="postal_code"
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <>

                                        <label style={{ color: "#000" }} >Postal Code</label>
                                        <Input  className='form-control p-2' fullWidth placeholder="Postal code" {...field} invalid={errors.postal_code}  />
                                        <FormFeedback invalid={errors.postal_code} >{errors?.postal_code?.message}</FormFeedback>

                                    </>
                                )}
                            />

                        </Grid>
                    )}
                    <Grid sm={12} xs={12} md={6} mt={2} px={1}  >
                        <Controller
                            control={control}
                            name="identity"
                            rules={{ required: true }}
                            render={({ field: { onBlur, onChange, value } }) => (
                                <>

                                    <label style={{ color: "#000" }}>ID Card Image</label>
                                    <Input  
                                        className='form-control p-2' 
                                        fullWidth 
                                        type="file" 
                                        value={value} 
                                        onBlur={onBlur} 
                                        inputProps={{ 
                                            onChange: async (e) => { 
                                                const file = e.target.files?.[0];
                                                if (file) {
                                                    onChange(e); 
                                                    await onChangeFiles(file, "identity");
                                                }
                                            },
                                            accept: "image/*,.pdf,.doc,.docx"
                                        }} 
                                        invalid={errors?.identity || fileError?.identity}   
                                    />
                                    <FormFeedback invalid={errors?.identity?.message || fileError?.identity?.message} >{errors?.identity?.message || fileError?.identity?.message}</FormFeedback>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                                        <Box>
                                            <span className='image-detail' >Select  image</span><br />
                                            <span className='image-detail' >Maximum file size: 50MB</span>

                                        </Box>

                                    </Box>
                                </>
                            )}
                        />


                    </Grid>
                    <Grid item mt={3} display={"flex"} justifyContent={"center"} sx={{ width: "100%" }}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={account === null || Object.keys(account).length === 0 ? handleSubmit(onSubmit) : handleSubmit(updateAccount)}

                            sx={{ p: 1, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                        >

                            {formBusy ? "Please wait..." : "Save Account Detail"}
                        </Button>
                    </Grid>
                    <Typography mb={2} mt={2} variant="h5" px={3} >Payment Information</Typography>
                    <Grid container >
                        <Grid item xs={12} md={12} px={3} >
                            <label style={{ color: "#000" }} >Name</label>
                            <TextField fullWidth type="text" />
                        </Grid>

                        <Grid item xs={12} md={12} px={3} mt={3} >
                            <label style={{ color: "#000" }} >Card Number</label>
                            <Box border={"solid 1px rgba(0, 0, 0, 0.23)"} px={1} p="16.5px 14px" borderRadius={1}  >
                                <CardNumberElement options={elementStyle} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} px={3} mt={3} >
                            <label style={{ color: "#000" }} >Expiry Date</label>
                            <Box border={"solid 1px rgba(0, 0, 0, 0.23)"} px={1} p="16.5px 14px" borderRadius={1}  >
                                <CardExpiryElement options={elementStyle} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} px={3} mt={3} >
                            <label style={{ color: "#000" }} >CVC</label>
                            <Box border={"solid 1px rgba(0, 0, 0, 0.23)"} px={1} p="16.5px 14px" borderRadius={1}  >
                                <CardCvcElement options={elementStyle} />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item mt={3} display={"flex"} justifyContent={"center"} sx={{ width: "100%" }}>
                        <Button
                            variant="contained"
                            color="secondary"


                            sx={{ p: 1, my: 2, backgroundColor: "#92c323", '&:hover': { backgroundColor: "#76a521" } }}
                        >

                            Save Payment Detail
                        </Button>
                    </Grid>
                </Grid>
            </>

        </div>
    )
}

export default PaymentComponent